import {ChangeDetectorRef, Component, Inject, ViewChild, ViewContainerRef} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DomService} from '../../../services/dom-service/dom.service';
import {ProductServiceComponent} from './templates/product-service/product-service.component';
import {
  ERROR_CODE_PROD_SERV_NOT_FOUND_1,
  ERROR_MSG_PROD_SERV_NOT_FOUND_1,
  ERROR_TITLE_PROD_SERV_NOT_FOUND_DEFAULT,
} from './popup.constants';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.css'],
})

export class PopUpComponent {
  @ViewChild('data', {read: ViewContainerRef}) templateContainer: ViewContainerRef;

  title: string;
  restrictedData: boolean;
  errorText: string;
  hasData = true;
  data;
  component;

  constructor(private domService: DomService, private changeRef: ChangeDetectorRef,
              public dialogRef: MatDialogRef<PopUpComponent>,
              @Inject(MAT_DIALOG_DATA) public inputData: any) {
    this.title = '';

    if (!inputData.product || (inputData.problem && inputData.problem.length)) {
      this.createErrorMessage(inputData);
      this.hasData = false;
    } else {
      this.title = `${this.inputData.product.productName} - ${this.inputData.product.productIdentificationNumber}` || '';
      this.data = inputData;
      this.restrictedData = inputData['restrictedData'] || [];
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  ngAfterViewInit() {
    this.addValues(this.data);
    this.changeRef.detectChanges();
  }

  onClick() {

  }

  createErrorMessage(error) {
    if (error.message !== '') {
      if (error.status === 404 || error.status === 500) {
        this.title = 'Kan productservices niet vinden';
      }
      this.errorText = error.statusText;
    }

    if (error.problem && error.problem.length &&
        error.problem[0].cause.code === ERROR_CODE_PROD_SERV_NOT_FOUND_1) {
      this.title = ERROR_TITLE_PROD_SERV_NOT_FOUND_DEFAULT;
      this.errorText = ERROR_MSG_PROD_SERV_NOT_FOUND_1;
    }
  }

  addValues(response) {
    this.data = response;
    this.createPopUpComponent();
  }

  private createPopUpComponent() {
    const viewRef = this.domService.addComponentToDOM(ProductServiceComponent, this.templateContainer);
    const componentToReturn = viewRef.instance as ProductServiceComponent;
    return this.setBasicComponentValues(componentToReturn);
  }

  private setBasicComponentValues(componentToReturn) {
    componentToReturn.data = this.data || {};
    componentToReturn.restrictedData = this.restrictedData;
    componentToReturn.errorText = this.errorText;
    return componentToReturn;
  }
}
